import React from "react";

export default function BackgroundImage({ image, overlay = true, opacity = 0.55, children }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {overlay && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: `rgba(0,0,0,${opacity})`,
            backdropFilter: "blur(4px)",
          }}
        />
      )}
    </div>
  );
}
